{
  "sections_page": {
    "title": "Locations",
    "title_for_company": "{company} - Locations",
    "add_button": "Add location",
    "description": "Group a company's customers into a hierarchy of locations. Each location inherits the settings of the locations above it.",
    "description_company_sync": "Group a company's customers into a hierarchy of locations. Each location inherits the settings of the locations above it. Company sync is on, so new locations are created on your eCommerce platform.",
    "load_error": "We couldn't load this company's locations. Please try again.",
    "empty_state": {
      "title": "No locations yet",
      "subtitle": "Add a location to start grouping this company's customers."
    }
  },
  "section_form_page": {
    "create_title": "Create location",
    "edit_title": "Edit {name}",
    "description": "Group customers within a company and override the settings they inherit.",
    "details": {
      "title": "Details",
      "name_label": "Location name",
      "name_placeholder": "e.g. North region",
      "external_id_label": "Platform ID",
      "external_id_placeholder": "Identifier on your eCommerce platform",
      "integration_id_label": "Integration ID",
      "integration_id_placeholder": "Identifier in another integration",
      "accounting_id_label": "Accounting ID",
      "accounting_id_placeholder": "Identifier in your accounting system"
    },
    "context": {
      "title": "Settings",
      "description": "Settings applied to customers belonging to this location."
    },
    "delete_confirm_title": "Delete location",
    "delete_confirm_body": "Are you sure you want to delete {name}? This can't be undone.",
    "company_sync_read_only": "Company sync is on, so this location is managed on your eCommerce platform. Make any changes there and they'll sync across.",
    "company_sync_blocked": {
      "message": "Company sync is on, so locations can't be created here. Create the location on your eCommerce platform and it will sync across.",
      "back_button": "Back to locations"
    }
  }
}
